"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnFormStateChange = void 0;
const react_hook_form_1 = require("react-hook-form");
const use_debounce_1 = require("use-debounce");
const react_hooks_1 = require("@framework/react-hooks");
const OnFormStateChange = props => {
    const { onFormStateChange } = props;
    const form = (0, react_hook_form_1.useFormContext)();
    const { formState: { isDirty, isValid, errors, touchedFields, dirtyFields }, getValues, } = form;
    const values = getValues();
    const debouncedOnFormStateChange = (0, use_debounce_1.useDebouncedCallback)(async () => {
        await onFormStateChange(form);
    }, 300);
    (0, react_hooks_1.useDeepCompareEffect)(() => {
        void debouncedOnFormStateChange();
    }, [{ isDirty, isValid }, errors, touchedFields, dirtyFields, values]);
    return null;
};
exports.OnFormStateChange = OnFormStateChange;
//# sourceMappingURL=index.js.map